
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 21","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 10.5c0 5.253-4.247 9.5-9.5 9.5A9.492 9.492 0 011 10.5C1 5.247 5.247 1 10.5 1S20 5.247 20 10.5z","fill":"currentColor","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M9.836 15.883c-.879 0-1.553-.158-2.022-.475-.468-.316-.703-.76-.703-1.33 0-.398.125-.736.375-1.013.25-.274.608-.463 1.073-.569a1.195 1.195 0 01-.457-.363.911.911 0 01-.188-.557c0-.242.068-.449.205-.62.137-.173.342-.339.615-.499a1.787 1.787 0 01-.82-.703C7.711 9.426 7.61 9.04 7.61 8.6c0-.47.1-.868.3-1.196.198-.332.49-.584.872-.756.383-.175.846-.263 1.389-.263.117 0 .244.008.38.023.141.012.27.028.387.047.122.016.213.033.276.053h2.244v.767l-1.102.205a1.935 1.935 0 01.346 1.125c0 .672-.232 1.202-.697 1.588-.461.383-1.098.575-1.91.575a6.567 6.567 0 01-.569-.047c-.14.086-.248.181-.322.287a.571.571 0 00-.111.346.33.33 0 00.111.257c.074.063.184.11.328.141.149.031.328.047.54.047h1.119c.71 0 1.253.15 1.628.451.375.3.563.742.563 1.324 0 .739-.305 1.307-.914 1.705-.61.403-1.487.604-2.631.604zm.053-.967c.48 0 .884-.047 1.213-.14.328-.094.576-.23.744-.405a.85.85 0 00.252-.615c0-.211-.053-.373-.159-.486-.105-.114-.263-.192-.474-.235a4.017 4.017 0 00-.785-.064H9.66c-.254 0-.478.039-.674.117-.195.082-.347.2-.457.352a.943.943 0 00-.158.55c0 .297.131.526.393.686.265.16.64.24 1.125.24zm.27-5.05c.401 0 .7-.11.896-.329.195-.223.293-.535.293-.937 0-.438-.102-.766-.305-.985-.2-.219-.496-.328-.89-.328-.387 0-.682.111-.885.334-.2.223-.3.553-.3.99 0 .395.1.703.3.926.203.219.5.328.89.328z","fill":"#fff"}})])
          )
        }
      }
    